// extracted by mini-css-extract-plugin
export default {"loader":"InfiniteScrollWaypoint-module__loader--sfkxM"};